<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Internal Assessment Marks</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <!-- <add-exam-setup @created="handleCreated"/> -->
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="row">
          <!-- Session Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-select
              size="default"
              v-model="selectedSession"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleSessionChange"
              :filterOption="false"
              :defaultValue="currentSession ? currentSession.id : ''"
            >
            <template v-for="schoolSession in schoolSessions">
              <a-select-option :value="schoolSession.id" :key="schoolSession.id">
                  {{schoolSession.name}}
                  <small class="text-primary ml-2">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
              </a-select-option>
            </template>
            </a-select>
          </div>
          <!-- Class Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-spin :spinning="classSpinning">
              <a-select
                size="default"
                v-model="selectedClass"
                placeholder="Select Class"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleClassSelect"
                :filterOption="false"
              >
                <template v-for="schoolClass in data">
                  <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                  {{schoolClass.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <a-spin :spinning="loading">
              <internal-marks-table
                :loading="loading"
                :data="selectedClassData"
                :session="selectedSession"
                :classId="selectedClass"
                :sections="classSections"
                @updateTable="handleUpdateTable"
              />
            </a-spin>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { find } from 'lodash'

import InternalMarksTable from '@/components/exam/internal/Table/index'
// import AddExamSetup from '@/components/exam/final/Forms/Add/index'

export default {
  components: {
    InternalMarksTable,
    // AddExamSetup,
  },
  mounted: function() {
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id
      })
      .catch(error => {
        this.$neoNotify.error(error)
      })
    this.getFinalResultSettings()
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      classSpinning: false,
      schoolClasses: [],
      selectedSession: undefined,
      selectedClass: undefined,
      classSections: [],
      schoolSessions: [],
      data: [],
      selectedClassData: null,
    }
  },
  methods: {
    getFinalResultSettings: function() {
      this.loading = true
      this.classSpinning = true
      this.$http.get('/api/finalresultsetting', {
        params: {
          session_id: this.selectedSession,
        },
      }).then(({ data }) => {
        this.loading = false
        this.classSpinning = false
        this.data = data.data
      })
    },
    handleCreated: function() {
      this.getFinalResultSettings()
    },
    handleUpdateTable: function() {
      this.getFinalResultSettings()
    },
    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }
      this.getFinalResultSettings()
    },
    handleClassSelect(value) {
      this.selectedData = null
      this.classSections = []
      if (value) {
        this.getClassSections(value)
        this.selectedClassData = find(this.data, { id: value })
      }
    },
    getClassSections(value) {
      this.loading = true
      this.$http.get(`/api/section/class/${value}`, {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.loading = false
          this.classSections = data.data
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },
  },
}
</script>
